import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import store from './redux/store';


const theme = createTheme({
  palette: {
    primary: {
      main: '#F43232'
    },
    action: {
      disabled: '#F4323270',
      disabledBackground: '#F4323270',
    }
  },
  typography: {
    fontFamily: 'Lato, Segoe UI',
    fontSize: 14
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </Provider>
  </BrowserRouter>
);

// field agent - onboard customer, initiate withdrawal, deposit, transfer
// https://www.figma.com/file/R02Hw2mYY6SazVlZv5CK0Z/Thrift-App?node-id=0%3A1
// field agents should have access to customers api
